angular.module('impactx.basketLink').directive('ixBasketLink', function () {
    return {
        scope: {
            product : '=',
            buttonLabel :'=',
            basketLink: '=',
            amountLabel: '=',
            configLabel: "=",
            fullyConfigured: "=",
            detailsFunction: "&",
            index: "@",
            isDetails: '=',
            vCatId: "="
        },
        restrict:'E',
        templateUrl: 'shared/basketlink/templates/basketlink.html',
        transclude: true,
        controller: 'BasketLinkCtrl',
        controllerAs: "basketLinkCtrl"
    };
});